import React from "react";
import { ShelterBedMetric } from "./ShelterBedMetric";

export const ShelterOccupancyPercentageMetric = ({ data }: any) => (
  <ShelterBedMetric
    data={data}
    title="Occupancy %"
    subtitle=""
    tooltip="Occupied beds as a share of all beds. This is the figure HMIS and funders call bed utilization."
    field="occupancy_rate"
    asPercent
  />
);
